/**
 * Container for NotFound
 *
 * @module containers/NotFound
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import AnonHeader from '../../components/AnonHeader/AnonHeader';
import ButtonLink from '../../components/ButtonLink';
import Footer from '../../components/Footer/Footer';
import BgSetter from '../../components/lib/BgSetter';
import { BgSettings } from '../../constants/App';
import { messages as m } from '../../constants/NotFound';
import { getInDomain } from '../../domains/externalUtils';
import { isAnonymousListener } from '../../lib/ListenerUtils';
import { getBrowsePath, getCollectionPath, isTmobileBrowsePath } from '../../lib/RouteUtils';

import './NotFound.scss';

class NotFound extends React.Component {
  static propTypes = {
    isAnon: PropTypes.bool.isRequired,
    // t-mobile views are not supported on desktop, need to show alternate message
    shouldShowTmobilePlaceholder: PropTypes.bool.isRequired,
  };

  render() {
    const heading = this.props.shouldShowTmobilePlaceholder ? m.pageNotAvailable : m.pageNotFound;
    const information = this.props.shouldShowTmobilePlaceholder
      ? m.notAvailableInfo
      : m.notFoundInfo;
    const options = this.props.shouldShowTmobilePlaceholder
      ? m.notAvailableOptions
      : m.tryOneOfTheseOptions;
    const notAvailableTag = <FormattedMessage {...m.notAvailableTag} />;
    return (
      <div>
        {this.props.isAnon && <AnonHeader />}
        <div className='NotFound'>
          <h1 className='NotFound__heading'>
            <FormattedMessage {...heading} />
          </h1>
          <h2 className='NotFound__information'>
            <FormattedMessage {...information} />
          </h2>
          <h4 className='NotFound__subHeading'>
            <FormattedMessage
              {...options}
              values={{
                url: (
                  <a className='OfferLink' href='/legal/promotions'>
                    {notAvailableTag}
                  </a>
                ),
              }}
            />
          </h4>
          {this.props.shouldShowTmobilePlaceholder && (
            <h4 className='NotFound__subHeading'>
              <FormattedMessage {...m.notAvailableFarewell} />
            </h4>
          )}
          {!this.props.shouldShowTmobilePlaceholder && (
            <div className='NotFound__button-container'>
              <ButtonLink to={getCollectionPath()} title={m.myCollection} />
              <ButtonLink to={getBrowsePath()} title={m.browse} />
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const previousPath = getInDomain('application.utils.getPreviousPath')(state);
  return {
    isAnon: isAnonymousListener(state),
    shouldShowTmobilePlaceholder: isTmobileBrowsePath(previousPath),
  };
}

export default connect(mapStateToProps)(BgSetter(NotFound, BgSettings.APP_NOT_FOUND));
